import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=46fa7d70&scoped=true"
import script from "./deal.vue?vue&type=script&lang=js"
export * from "./deal.vue?vue&type=script&lang=js"
import style0 from "./deal.vue?vue&type=style&index=0&id=46fa7d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fa7d70",
  null
  
)

export default component.exports